// extracted by css-extract-rspack-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed__eh13Y","compact":"DiffLines-module__compact__wmHnv"};